<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span
        class="d-flex justify-content-between align-items-center m-3 pb-3 globalborder-btm-header">
        <span class="col-auto">
          <h2 class="mb-0">Quick Client Verification</h2>
        </span>
        <span class="d-flex gap-2 customizefilter-btn"> </span>
      </span>
      <div class="col-12">
        <div class="m-3">
          <form class="row" [formGroup]="verifyClientForm">
            <div class="col mb-12">
              <div class="form-group has-float-label">
                <label class="form-label" for="c_name"
                  >Client Name<span></span
                ></label>
                <input
                  pInputText
                  jniAutoCompleteBlocker
                  type="text"
                  class="form-control"
                  id="c_name"
                  name="c_name"
                  placeholder=""
                  formControlName="clientName"
                  [ngClass]="{ 'has-error': formErrors['clientName'] }"
                  (blur)="logValidationErrors()"
                  (focusout)="trimValue($event)"
                  (keydown.enter)="vefifyClient($event)" />

                <span class="error-msg" *ngIf="formErrors['clientName']">
                  {{ formErrors["clientName"] }}
                </span>
              </div>
            </div>

            <div class="col mb-12">
              <div class="form-group has-float-label">
                <label class="form-label" for="c_Address"
                  >Client Street Address</label
                >
                <input
                  pInputText
                  jniAutoCompleteBlocker
                  type="text"
                  class="form-control"
                  id="c_Address"
                  name="c_Address"
                  placeholder=""
                  formControlName="streetAddress"
                  (focusout)="trimValue($event)"
                  (keydown.enter)="vefifyClient($event)" />

                <span class="error-msg" *ngIf="formErrors['streetAddress']">
                  {{ formErrors["streetAddress"] }}
                </span>
              </div>
            </div>

            <div class="col mb-12">
              <div class="form-group has-float-label">
                <label class="form-label" for="url">URL</label>
                <input
                  pInputText
                  jniAutoCompleteBlocker
                  type="text"
                  class="form-control"
                  id="url"
                  name="url"
                  placeholder=""
                  formControlName="companyUrl"
                  [ngClass]="{ 'has-error': formErrors['companyUrl'] }"
                  (blur)="logValidationErrors()"
                  (focusout)="trimValue($event)"
                  (keydown.enter)="vefifyClient($event)" />

                <span class="error-msg" *ngIf="formErrors['companyUrl']">
                  {{ formErrors["companyUrl"] }}
                </span>
              </div>
            </div>

            <div
              class="col-auto d-flex align-items-center justify-content-between centerVerifyBtn mt-4">
              <p-button label="Verify" (click)="onClientVerify()" />
            </div>
          </form>
        </div>
      </div>
      <div class="col-12">
        <p-table
          #dt
          stripedRows
          [value]="verifyClientList"
          styleClass="p-datatable-customers verify-client-listing"
          [rowHover]="true"
          [rows]="10"
          [showCurrentPageReport]="true"
          [scrollable]="true"
          scrollHeight="calc(100vh - 310px)"
          [size]="'small'"
          [rowsPerPageOptions]="[10, 25, 50]"
          [paginator]="false"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          [filterDelay]="0"
          styleClass="table-listing">
          <ng-template pTemplate="header">
            <tr class="table-head">
              <th>&nbsp;</th>
              <th
                pSortableColumn="clientName"
                [ngClass]="{ trimmedby30char: descriptionCharacterCond }">
                Client Name
                <p-sortIcon field="clientName"></p-sortIcon>
              </th>
              <th class="address">Address</th>
              <th>BC</th>
              <th>Protection</th>
              <th class="date">Last Order Date</th>
              <th class="date">Last Invoiced</th>
              <th>Cust#</th>
            </tr>
            <tr>
              <th></th>
              <th>
                <div class="d-flex">
                  <input
                    pInputText
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="clientName"
                    id="clientName"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'clientName',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    pInputText
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="clientPrimaryAddress"
                    id="clientPrimaryAddress"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'clientPrimaryAddress',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-verifyClientList
            let-rowIndex="rowIndex">
            <tr
              class="p-selectable-row"
              [pSelectableRow]="verifyClientList"
              [pSelectableRowIndex]="rowIndex">
              <td></td>
              <td
                [ngClass]="{
                  'trimmeddescription trimmedby30char':
                    descriptionCharacterCond,
                }">
                {{ descriptionCharacterCount(verifyClientList.clientName) }}
                {{ verifyClientList.clientName }}
              </td>
              <td class="address">
                {{ verifyClientList.clientPrimaryAddress }}
              </td>
              <td>{{ verifyClientList.brandingconsultant }}</td>
              <td>
                <span class="pt-value">{{
                  verifyClientList.protectionNumber
                }}</span>
                <i
                  *ngIf="verifyClientList.protectionNumber !== 0"
                  class="icon icon-Protection-days ms-1"></i>
                <i
                  *ngIf="verifyClientList.protectionNumber === 0"
                  class="icon danger icon-Protection-days ms-1"></i>
              </td>
              <td class="date">
                <span *ngIf="verifyClientList.lastOrderDate | hidedynamicsdate">
                  {{ verifyClientList.lastOrderDate | date: "MM-dd-yyyy" }}
                </span>
              </td>

              <td class="date">
                <span
                  *ngIf="verifyClientList.lastInvoiceDate | hidedynamicsdate">
                  {{ verifyClientList.lastInvoiceDate | date: "MM-dd-yyyy" }}
                </span>
              </td>

              <td>{{ verifyClientList.customerAccount }}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="20">No clients found.</td>
            </tr>
          </ng-template>
        </p-table>

        <div class="clients-note text-end p-3 pb-1">
          <p-button
            label="Submit"
            *ngIf="showCompleteFullVerificationAndCreate"
            (click)="redirectToCreateClient()" />
        </div>
      </div>
    </p-card>
  </div>
</div>
<jni-modal-stacker
  *ngIf="showModalVerifyClient"
  [displayModal]="showModalVerifyClient"
  (closeEvent)="closeModalForVerifyClient()">
  <h1 class="panelHeading">Verify Client</h1>
  <div class="panelBody">
    <jni-verify-client [verifyClientDtoFromQuickScreen]="verifyClientDto">
    </jni-verify-client>
  </div>
</jni-modal-stacker>
